import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateMachineTimesDto = ClientInferResponseBody<
  typeof contract.optimizations.updateMachineTimes
>;

export const updateMachineTimes = async ({
  optimizationId,
  machinePreparationTime,
  otherMachineTime,
}: {
  optimizationId: string;
  machinePreparationTime: number;
  otherMachineTime: number;
}): Promise<UpdateMachineTimesDto> => {
  const response = await api.optimizations.updateMachineTimes.mutation({
    params: { id: optimizationId },
    body: { machinePreparationTime, otherMachineTime },
  });

  if (response.status !== 200) {
    throw new ApiError("Error updating machine times", response.status, response.body);
  }

  return response.body;
};
